import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  input: {
    marginLeft: theme.spacing(1),
    color: '#7833FF',

    '&::before, &::after': {
      display: 'none',
    },
  },
  button: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    borderRadius: 40,
    backgroundColor: theme.palette.common.white,
  },
  masonryRoot: {
    display: 'flex',
  },
  masonryColumn: {
    '&:not(:last-child)': {
      marginRight: theme.spacing(0.75),
    },
  },
  buttonShowMore: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    borderRadius: 40,
    backgroundColor: '#7833FF',
    color: '#FFFFFF',
    fontWeight: 'bold',

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
}));
